import React from 'react';

interface NativeAppInsetsProps {
  children: React.ReactNode;
  className?: string;
  /**
   * Whether to pad for the device's safe areas.
   *
   * `false` for a surface that handles its own, which is anything with a bar
   * pinned to an edge: the padding has to be *inside* the bar so its
   * background reaches under the status bar and content scrolls beneath it,
   * and a container that also pads pushes the whole surface down by the inset
   * a second time. The wrapper's layout role (full width, fills its parent,
   * a positioning context for anything absolute inside) is kept either way.
   */
  insets?: boolean;
  /**
   * Pass the parent's definite height straight through to the child instead of
   * growing with content: a column that can shrink below its content, so a
   * scroller inside it scrolls rather than making the page taller. Only for
   * surfaces whose parent *has* a definite height — see `routeOwnsViewport` in
   * MainApp. Off everywhere else, where growing with content is the point.
   */
  fill?: boolean;
}

export const NativeAppInsets: React.FC<NativeAppInsetsProps> = ({
  children,
  className = '',
  insets = true,
  fill = false,
}) => {
  return (
    <div
      className={`w-full flex-1 ${
        insets ? 'top-safe-padding bottom-safe-padding' : ''
      } ${fill ? 'flex flex-col min-h-0' : ''} ${className} relative`}
    >
      {children}
    </div>
  );
};
